/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디 
 * - sponserName: 후원인 이름 
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성 
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleServiceCallCenter from '../service/callCenter'
import GentleProxy from '../common/proxy';
import GentleServiceSearch from './search';
import GentleServiceCart from './cart';
import language from '../lang';
import GentleAppState from '../common/appstate';
import GentleServiceAccount from './account';

var GentleServiceProduct = Object.create( GentleWidget)

// 상품목록
GentleServiceProduct.list = function(array, quickReplies){
    // searchMode : 검색에서 호출하는 경우 퀵리플라이 구성
    console.log('GentleServiceProduct.list', array);
    const html_container = `<div>`
    let $container = $(html_container);
    //const $list = $container.find('[name="list"]');

    let $card;

    for (let index = 0; index < 2; index++) {
        const element = array[index];
        if(element !== undefined){

        console.log('element>', element);

        // data bind
        const button_title = (element.IsSoldOut && element.IsReOpenNotifyMode) ?  GentleLang.translateService(language.product, language.product.type.AlarmRegist) : GentleLang.translate(GentleLang.type.ProductDetailView);
        // 2022-api : 제품목록
        // ???

        // const {ThumbImageUrl, Name, CustPrice, PvPrice, PCDetailUrl, MobileDetailUrl} = element;

        // 2022-api : 제품목록
        const {imageUrl:images} = element;
        const ThumbImageUrl = (images && images.length > 0) ? images[0] : ""
        const {name:Name, memRetailPrice: CustPrice, pvPrice:PvPrice, image:PCDetailUrl, image:MobileDetailUrl} = element;

        const price = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(CustPrice)});
        const pvPrice = GentleUtil.comma(PvPrice);
        const url = GentleAppState.isPc? PCDetailUrl : MobileDetailUrl;
        let isSold = (!element.IsSoldOut && !element.IsReOpenNotifyMode) ? "available Order" : "soldout";
        // 2022-api : 제품목록
        // ???

        /*
        at-new : 신상품
        at-limited : 품절
        at-soldout : 한정
        at-season : 시즌
        at-transit : 배송중
        at-delivered : 배송완료
        */

        /**
        IsNew	bool		신상품여부
        IsSaleLimit	bool		한정상품여부
        IsSaleSeason	bool		시즌상품여부
        IsSoldOut	bool		품절여부
        IsReOpenNotifyMode   bool 재판매알림여부
        OutCompleteGubun	bool		완판여부, 품절시 사용
        IsSaleDiscontinued	bool		단종여부, 품절시 사용
        */

        /**
        <i class="at-badge at-new"></i>
        <i class="at-badge at-limited"></i>
        <i class="at-badge at-season"></i>
        <i class="at-badge at-soldout"></i>
         */
        let badge = '';
        const {IsNew, IsSaleLimit, IsSaleSeason, IsSoldOut, IsReOpenNotifyMode} = element;
        // 2022-api : 제품목록
        // ???

        if(IsNew) badge += `
        <i class="at-badge at-new"></i>`;
        if(IsSaleLimit) badge += `
        <i class="at-badge at-limited"></i>`;
        if(IsSaleSeason) badge += `
        <i class="at-badge at-season"></i>`;
        if(IsSoldOut&&IsReOpenNotifyMode) badge += `
        <i class="at-badge at-soldout"></i>`;

        let html = `
        <div class="card-view">
            <div class="product-container default" name="list">
                <div class="product-card">
                    <figure class="product-thumbnail">
                        <img src="${ThumbImageUrl}">
                    </figure>
                    <div class="product-summary">
                        <div class="flex-box">
                            ${badge}
                        </div>
                        <h3>${Name}</h3>
                        <div class="flex-box-2 space-beetween">
                            <span><strong class="price">${price}</strong></span>
                            <span><strong class="pv">${pvPrice}</strong> PV</span>
                        </div>
                    </div>
                </div>
                <div class="gentle-button-group">
                    <div class="half-button">
                        <button type="button" class="secondary default" name="link">상품URL 복사</button>
                        <button type="button" class="primary default" name="${isSold}">${button_title}</button>
                    </div>
                </div>
            </div>
        </div>
        `;

        element.button_title = button_title;
        
        //const html = html_template.GentleFormat(element);
        console.log("isSold? >>> ", isSold)
        $card = $(html);
        
        $card.find('[name="soldout"]').bind('click',function(event) {
            event.stopPropagation();
            console.log('재판매 알림 신청하기!!!!')
            let url = (GentleAppState.isPc) ? language.url.pc.ProductDetails : language.url.mobile.ProductDetails;
                        console.log(element);
                        const {Id} = element;
                        url = url.GentleFormat({Id});
                        console.log('url>', url);
                        window.open(url);
            //to do    
        });
    
        // 장바구니 담기
        {
            const onClickAdd = function(event){
                event.stopPropagation();

                // 비회원 / 비로인지원을 위해...
                // if(false === GentleAppState.isLogin)
                // {
                //     GentleComponentBubble.insertUserBubble({html: button_title, send: false});    
                //     GentleServiceAccount.login({fallback: 'true'})
                //     return;
                // }
            
                console.log("장바구니 담기 : ", element);
                GentleServiceProduct.popupOption(element); 
            }
            $card.find('[name="cart"]').bind('click', onClickAdd);
        }

        // 상품자세히 보기
        {
            const onClickDetail = function(){
                console.log('clicked');
                GentleComponentBubble.insertUserBubble({html:Name, send:false});
                GentleServiceSearch.info(element)

                var quickReply = Object.create( GentleComponentQuickReply);   

                // 하이브리드 앱 링크 분기
                const browserInfo = window.navigator.userAgent;
                const isHybrid = browserInfo.includes('MARKET_GOOGLE') || browserInfo.includes('MARKET_APPSTORE');
                
                // todo : 제품상세
                let buttons = [];
                {
                    const onClickDetail = function() {
                        console.log('language.product.type.Detail');
                        let url = (GentleAppState.isPc) ? language.url.pc.ProductDetails : language.url.mobile.ProductDetails;
                        console.log(element);

                        function idChecking(data) {
                            if(data.materialCode === undefined){
                              const { Id } = data;
                              return Id 
                            }else {
                              const { materialCode: Id } = data;
                              return Id 
                            } 
                          }
                
                        const Id = idChecking(element)
                        // const {Id} = element;
                        url = url.GentleFormat({Id});
                        console.log('url>', url);
                        isHybrid ? window.open(url, '_self') : (GentleAppState.isPc) ? window.open(url) : window.location.href = url;
                    };
                    buttons = [
                        {
                            send: false,
                            title: GentleLang.translateService(language.product, language.product.type.Detail),
                            onClick: onClickDetail,
                        },
                    ];
                }
                buttons = buttons.concat(quickReplies);
                
                quickReply.createComponent(buttons);
                quickReply.insert();

                GentleUtil.timeStamp();
            }
            $card.find('div').eq(0).bind('click', onClickDetail);
        }

        }else{
            
        }

        // 링크복사
        {
            const onClickLink = function(event){
                let urlCopy = (GentleAppState.isPc) ? language.url.pc.ProductDetails : language.url.mobile.ProductDetails;

                const { materialCode: Id } = element;
                urlCopy = urlCopy.GentleFormat({Id});

                console.log("url 복사 : ", urlCopy);

                GentleUtil.copyTextToClipboard(urlCopy, function(result){
                    if(result === true){
                        GentleUtil.createToastMessage(GentleLang.translate(GentleLang.type.CopiedURL));
                    }else{
                        GentleUtil.createToastMessage(GentleLang.translate(GentleLang.type.FailedCopyURL));
                    }
                });
                event.stopPropagation();
            }
            $card.find('[name="link"]').bind('click', onClickLink);
        }
        
        $container.append($card);
    }   
    return $container;
}

// 신상품 목록
GentleServiceProduct.newList = function(json){
    const {isLoaded} = json ? json : {};
    GentleServiceProduct.bestList({isNew: true, isLoaded});
}

// 인기상품 목록
GentleServiceProduct.bestList = function(obj)
{
    {
        const bubble = GentleUtil.notSupported();
        bubble.insert();
        return;
    }


//     // console.log('GentleServiceProduct.bestList', isNew);
//     // isNew : 신상품 조회의 경우 true
//     // isLoad : 최초 로딩 하면의 경우 true
//     // 20221121 인기상품은 제거되어 더이상 사용되지않음
//     const {isNew, isLoaded} = obj ? obj : {};
//     const component =  Object.create(this);

//     let curPage = 1;
//     const PageSize = 2;

//     // api
//     const request = function(PageNo, isNew=false){
//         console.log('request', PageNo);

//         const onSuccess = function(data){
//             console.log('onSuccess>', data);
//             switch(data.Status){
//             case 1:
//                 const { Data } = data;
//                 console.log('Data>', Data);

//                 if(Data.List.length > 0){
//                     curPage = PageNo;
//                 }
        
//                 render(Data);
//                 break;
//             default:
//                 break;
//             }
//         };
    
//         const onFailed = function(data){
//             console.log('onFailed');
//         }

//         const proxy = Object.create(GentleProxy);
//         const param = {PageNo, PageSize};
//         let formData = new FormData(); // new FromData()로 새로운 객체 생성
//         formData.append("binAtFirst", "3562"); // <input name="item" value="hi"> 와 같다.
//         formData.append("binAtLast", "1706");
//         formData.append("approvalNumber", "35621706");
//         formData.append("approvalDate", "20200616");
//         formData.append("amount", "306000");
//         console.log('isNew>', isNew)
//         if(isNew)   // 신상품

//             proxy.requestFormData("global-new", formData, onSuccess, onFailed );
//         else // 인기상품
//             // proxy.request("best", param, onSuccess, onFailed );
//             proxy.requestFormData("global-new", formData, onSuccess, onFailed );
//     }
//     request(1, isNew);


//     const render = function(data){
//         console.log('render', data);
//         const { PageNo, PageSize, TotalCount } = data;

//         console.log('isLoaded', isLoaded);
//         let htmls = [];
//         // if(isLoaded){   // 로그인 직후 로딩인가?
//         //     const {custName, MaxMasterShip} = GentleAppState;

//         //     // 직급자 아닐경우 : 안녕하세요, $user.name$님!
//         //     let html = GentleLang.translateService(language.product, language.product.type.Hello, {name: custName});

//         //     // 직급자의 경우 명목직급을 넣어 주세요:  Ex) 안녕하세요, 김토미 샤론로즈마스터님!
//         //     if(MaxMasterShip){
//         //         const level = GentleLang.mastershipType(MaxMasterShip);
//         //         html = GentleLang.translateService(language.product, language.product.type.Hello2, {name: custName, level});
//         //     }

//         //     htmls.push(html);
//         // }

//         // 봇버블
//         {
//             console.log('isNew>', isNew);
//             // let html = GentleLang.translateService(language.product, language.product.type.BestBot);
//             // if( isNew ){
//               let html = GentleLang.translateService(language.product, language.product.type.NewBot);
//             // } 

//             if(PageNo > 1){
//                 // html = GentleLang.translateService(language.product, language.product.type.BestMoreBot); 
//                 // if( isNew ) {
//                     html = GentleLang.translateService(language.product, language.product.type.NewMoreBot);
//                 // }
//             } 

//             htmls.push(html);

//             // var bubble = Object.create( GentleComponentBubble );   
//             // bubble.createComponent({
//             //         html,
//             // });     
//             // bubble.insert();     
//         }

//         var bubble = Object.create( GentleComponentBubble );   
//         bubble.createComponent({
//             html: htmls}
//         );     
//         bubble.insert();     


//         // 상품목록
//         const list = data.List.slice(0,2);

//         let $container = GentleServiceProduct.list(list, []);
//         component.insertElement($container);

//         // 하위 버튼
//         {
//             let buttons;
//             const onClickMore = function(){
//                 console.log('상품 더보기');
//                 request(PageNo + 1, isNew);
//             };

//             if(PageNo === 1)
//             {
//                 let text = GentleLang.translateService(language.product, language.product.type.BestMore);
//                 if(isNew) text = GentleLang.translateService(language.product, language.product.type.NewMore);

//                 buttons = [
//                     {
//                         send : false,
//                         isSecondary: true,
//                         isCardWidth: true,
//                         text,
//                         html : text,
//                         user: 'user',
//                         onClick: onClickMore
//                     }
//                 ];
//             }
//             else
//             {
//                 const onClickPre = function(){
//                     console.log('이전 상품보기');
//                     request(PageNo - 1);
//                 };

//                 buttons = [
//                     {
//                         send: false,
//                         isSecondary: true,
//                         isCardWidth: true,
//                         text: GentleLang.translateService(language.product, language.product.type.Pre),
//                         user: 'user',
//                         onClick: onClickPre
//                     }
//                 ];
    
//                 if( PageNo * PageSize < TotalCount ){   // todo : 더보기가 가능한 경우 판단
//                     const button = {
//                         send: false,
//                         isSecondary: true,
//                         isCardWidth: true,
//                         text: GentleLang.translate(GentleLang.type.NextProducts),
//                         user: 'user',
//                         onClick: onClickMore,
//                     };
//                     buttons = buttons.concat(button);
//                 }    
//             }
//             var buttonComponent = Object.create( GentleComponentButton);
//             buttonComponent.createComponent(buttons);
//             buttonComponent.insert();
//         }

//         // QuickReply 상품검색, 신상품
//         {
//             // const searchProduct = function(){
//             //     console.log('search Product')
//             //     GentleServiceSearch.main();
//             // };

//             let title = GentleLang.translate(GentleLang.type.NewProduct)
//             let text = GentleLang.translate(GentleLang.type.NewProduct);
//             // let onClick = newList;

//             if(isNew){                
//                 title = GentleLang.translate(GentleLang.type.BestProduct)
//                 text = GentleLang.translate(GentleLang.type.BestProduct);
//                 // onClick = bestList;
//             }

//             const option = [
//                 {
//                     // send: false,
//                     title: GentleLang.translateService(language.search, language.search.type.Search),
//                     text: GentleLang.translateService(language.search, language.search.type.Search),
//                     // onClick: searchProduct,
//                 },                
//                 {
//                     title,
//                     text,
//                     // onClick
//                 },
//             ]
//             var quickReply = Object.create( GentleComponentQuickReply);
//             quickReply.createComponent(option);
        
//             quickReply.insert();
//         }

//         GentleUtil.timeStamp();
//     };
}

// 옵션 선택
GentleServiceProduct.popupOption = function(data, isBuy = false){
    // GentleServiceCallCenter.disabledAPI()

    console.log('GentleServiceProduct.popupOption', data);

    //20221017
    // GentleUtil.updateSSOToken();
    // function checkId(data) {
    //     if(data.materialCode !== undefined){
    //             const {materialCode} = data
    //         return  {materialCode}
    //     }else {
    //             const {Id:materialCode} = data
    //         return  {materialCode}
    //     }
    // }
    const {id} = data
    const request = function(){
        const onSuccess = function(data){
            console.log('popupOption onSuccess>', data);
            switch(data.result){
            case "200":
                const { item } = data;
                console.log('Data>', item);
                
                // rows = rows.concat(Data.List);
                // addCard(Data.List);

                // if(Data.List.length > 0){
                //     page += 1;
                //     addCard(Data.List);
                //     rows = rows.concat(Data.List);
                // }
                if(isBuy===true){
                    item.buy=true;
                }else{
                    item.buy=false;
                }
                render(item);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {goodsNo:id};

        // proxy.request("global-product-detail", param, onSuccess, onFailed );
        proxy.request("2025-product-detail", param, onSuccess, onFailed );
    }

    const render = function(data){
        console.log('render', data);
        // let {Id, Name, CustPrice, PvPrice, ThumbImageUrl, GroupOptionType, GroupOptions} = data;
        /* 2022-api-제품 상세
        // let {id, productName, memSalePrice, pvPrice, ThumbImageUrl, GroupOptionType, GroupOptions} = data; //썸네일 이미지와 그룹옵션타입, 그룹옵션은 매칭을 찾을수없음
        */
        let {
            productName, 
            memRetailPrice, 
            pvPrice, 
            verticalThumbnailPc, 
            GroupOptionType, 
            GroupOptions, 
            meterialCode, 
            IsSoldOut, 
            IsReOpenNotifyMode, 
            buy
        } = data;
        let amount = 1;
        let totalPrice = Number(memRetailPrice);
        let totalPv = Number(pvPrice);
        let $price, $pv, $amount, $name;
        let ThumbImageUrl = verticalThumbnailPc
        let $buttonAdd; // 장바구니 담기 버튼
        let $buttonBuy; // 장바구니 담기 버튼

        // 총 결제금액, 총 PV 계산
        const calc = function(){
            // amount
            console.log('프라이스 & PV', pvPrice, memRetailPrice);
            $amount.attr('value', amount);

            // pv
            let val = Number(pvPrice) * amount;
            totalPv = val;
            $pv.html(GentleUtil.comma(val));

            // price
            val = Number(memRetailPrice) * amount;
            totalPrice = val;

            val = GentleUtil.comma(val);
            val = GentleLang.translate(GentleLang.type.CurrencyFormat3, {num: val});
            $price.html(val);
        }

        ///// data bind        
        const priceString = GentleLang.translate(GentleLang.type.CurrencyFormat3, {num:GentleUtil.comma(memRetailPrice)});
        const pvString = GentleUtil.comma(pvPrice);

        {
            const title = GentleLang.translate(GentleLang.type.OptionSelect);
            const titleAmount = GentleLang.translate(GentleLang.type.Amount);
            const titleButton = GentleLang.translate(GentleLang.type.OptionAdd);
            // const titleButtonBuy = GentleLang.translateService(language.product, language.product.type.Buy);
            const titleTotalPrice = GentleLang.translateService(language.order, language.order.type.TotalPrice);
            const titleTotalPV = GentleLang.translate(GentleLang.type.TotalPv);
            const qtyLang = GentleLang.translateService(language.product, language.product.type.CartAmount);
            const alarm = GentleLang.translateService(language.product, language.product.type.AlarmRegist);

            let post = '';
            
            // const {Id, IsSoldOut, IsReOpenNotifyMode, buy} = data;
            {
                post += `
                <input type = "hidden" name = "id" value="${meterialCode}">
                <input type = "hidden" name = "quantity" value="${amount}">`;
            };

            let switchedButton = '';
            
            if((IsSoldOut && IsReOpenNotifyMode)){
                switchedButton = `<button type="button" name="soldout" class="square big primary default">${alarm}</button>` //수정해야함
            }else{
                if(buy===true)
                {
                    // switchedButton = `<button type="button" name="buy" class="square big primary default">${titleButtonBuy}</button>`
                }else{
                    switchedButton = `<button type="button" class="square big primary disabled" name="add">${titleButton}</button>`

                }  
            }
            
            let html = `
            <div id="cart-container">
                <div name="options">
                </div>
                <div id="fixed-bottom-layer">
                    <div id="cart-push" name="has-option">
                        <div class="cart-qty">
                            <div class="flex-box space-between">
                                <div>${titleAmount}</div>
                                <div class="qty-group flex-box">
                                    <span class="plus" name="minus"><img src="/assets/images/atomy/cart-minus.svg"></span>
                                    <input type="text" readonly value="1" name="amount">
                                    <span class="minus" name="plus"><img src="/assets/images/atomy/cart-plus.svg"></span>
                                </div>
                            </div>                        
                            <div class="flex-box flex-justify-center qty-button-group">
                                <button name="plus3">+ 3${qtyLang}</button>
                                <button name="plus5">+ 5${qtyLang}</button>
                                <button name="plus10">+ 10${qtyLang}</button>
                            </div>                        
                        </div>
                        <div class="product-info">
                            <h3 name="name">${productName}</h3>
                            <div id="cart-total-price" class="flex-box space-between">
                                <span><strong class="bold">${titleTotalPrice}</strong></span>
                                <span name="price">${priceString}</span>
                            </div>                        
                            <div id="cart-total-pv" class="flex-box space-between">
                                <span>${titleTotalPV}</span>
                                <span><strong class="pv" name="pv">${pvString}</strong> PV</span>
                            </div>
                        </div>
                        <div class="gentle-button-group margin-zero">
                                <div class="wide-button">
                                    ${post}
                                    ${switchedButton}
                                </div>
                        </div>
                    </div>
                </div>
            </div>`;
            
            const $container = $(html);

            $amount = $container.find('[name="amount"');
            $price = $container.find('[name="price"');
            $pv = $container.find('[name="pv"]');
            $name = $container.find('[name="name"]');

            const updateName = function(item){
                const {ProductInfo} = item;
                const {Name} = ProductInfo;
                $name.html(Name);
            }

            // 수량 +
            $container.find('[name="plus"]').bind('click', function(){
                amount += 1;
                calc();
            });

            // 수량 -
            $container.find('[name="minus"]').bind('click', function(){
                if(amount == 1) return;
                amount -= 1;
                calc();
            });

            $container.find('[name="plus3"]').bind('click', function(){
                amount += 3;
                calc();
            });
            $container.find('[name="plus5"]').bind('click', function(){
                amount += 5;
                calc();
            });
            $container.find('[name="plus10"]').bind('click', function(){
                amount += 10;
                calc();
            });

            let selectedOption;
            let optionName;

            // 장바구니 담기
            $buttonAdd = $container.find('[name="add"]');            
            $buttonAdd.bind('click', function(){
                console.log("이 상태로 장바구니 담기");
                console.log(data)
                console.log(GroupOptions)
                const {materialCode:id, productName:name} = data;
                
                GentleComponentBubble.insertUserBubble({html:titleButton, send:false})
                GentleUtil.removeSlidePopup();
    //             // console.log('selectedOption>', selectedOption);

                GentleServiceCart.done({id, amount, name, totalPrice, totalPv, optionName, ThumbImageUrl});
            });

            $buttonBuy = $container.find('[name="buy"]');        

            // 구매하기
            $buttonBuy.bind('click', function(){
                console.log('구매하기', data);
                console.log('GentleAppState.isLogin>', GentleAppState.isLogin);
                if(GentleAppState.isLogin){
                    let params = '';
                    // for(let key in data)
                    {
                        const {materialCode} = data;
                        if(GentleAppState.isPc){
                            params += `gList=${materialCode}&qList=${amount}`;        
                        }else{
                            params += `Quantity=${amount}&Id=${materialCode}&`;
                        }
                        
                    };
                    const {materialCode:id, productName:name} = data;
                    GentleServiceCart.done({id, amount, name, totalPrice, totalPv, optionName, ThumbImageUrl});

                    let url = GentleAppState.isPc ? language.url.pc.BuyNow : language.url.mobile.BuyNow;
                    console.log('params>', params);
                    console.log('url>', url.GentleFormat({params}));
                    GentleUtil.ssoOpen(url + "?" + params);
                    // GentleComponentBubble.insertUserBubble({html:titleButtonBuy, send:false})
                    GentleUtil.removeSlidePopup();
                    // window.open("https://www.atomy.kr/v2/Home/Payment/OrderPayment");
                }
                else // 비로그인 구매
                {
                    const {materialCode} = data;
                    const ids = [materialCode]
                    const qtt = [amount];
                    const param = {
                        id:ids,
                        Quantity:qtt,
                        reservationid: 0,
                    }
    
                    GentleServiceCart.requestNomemberToken(param);
                }                
            }); 
        
            const options = [];
            const resetOptions = function(){
                options.forEach(element => {
                    element.removeClass('active');
                });
            }

            const $options = $container.find('[name="options"]');
            // if(GroupOptionType === 1)
            if(GroupOptionType > 0)
            {
                const $ul = $(`<ul class="product-option"></ul>`);

                // 라인부분 처리
                {
                    const $el = $container.find('[name="has-option"]');
                    $el.addClass('has-option');
                }

                GroupOptions.forEach(element => { // todo 
                    console.log('element', element);

                    const {Title, Value, Items} = element;
                    
                    if(Items)   // 옵션이 두가지인 경우
                    {
                        Items.forEach(item => {
                            let optionName = `${Value}`;

                            {
                                const {Value} = item;

                                optionName += ` / ${Value}`;
            
                                const option = `
                                <li>${optionName}</li>
                                `;
                                const $option = $(option);
            
                                options.push($option);
                                // $options.append($option);
                                $ul.append($option);
                
                                // click
                                $option.bind('click', function(){
                                    console.log("option selected : ", item);
                                    
                                    $buttonAdd.removeClass('disabled');
                                    $buttonAdd.addClass('default');
                                    // 
                                    resetOptions(); // reset all
                                    $option.addClass('active'); // select this
                
                                    selectedOption = item;
                                    updateName(selectedOption);
                                });
                            }
                        });
                    }
                    else    // 한가지 옵션
                    {    
                        const optionName = `${Title} / ${Value}`;
                        
                        const option = `
                        <li>${optionName}</li>
                        `;
                        const $option = $(option);
    
                        options.push($option);
                        // $options.append($option);
                        $ul.append($option);
        
                        // click
                        $option.bind('click', function(){
                            console.log("option selected : ", element);
                            CustPrice = Number(element.ProductInfo.CustPrice);
                            PvPrice = Number(element.ProductInfo.PvPrice);
                            $buttonAdd.removeClass('disabled');
                            $buttonAdd.addClass('default');
                            // 
                            resetOptions(); // reset all
                            $option.addClass('active'); // select this
        
                            selectedOption = element;
                            updateName(selectedOption);
                            calc();
                        });
                    }
                });
                $options.append($ul);
            }
            else{
                $options.remove();
                // 장바구니 담기 
                $buttonAdd.removeClass('disabled');
                $buttonAdd.addClass('default');
            }

            GentleUtil.createSlidePopup(
                {
                    title, 
                    content: $container,
                    bgColor: '#f2f5f7',
                    headerBgColor: '#fff'                
                });
        }
    };

    // render({});
    request();
}

export default GentleServiceProduct;